

export const sortTypeEnum = {
    NORMAL: "normal",
    DATE: "date",
    ARRAY: "array",
    NESTED_SECOND_PROP: " nested using secondProp",
};

export const chartResolutionEnum = {
    WEEKLY: 0,
    MONTHLY: 1,
    DAILY: 2
};

export const quickMenuActionEnum = {
    RENAME: "rename",
    SETTINGS: "settings",
    EDIT: "edit",
    DUPLICATE: "duplicate",
    MOVE: "moveTo",
    DELETE: "delete",
    DUPLICATE_ALL: "duplicateAll",
    DELETE_ALL: "deleteAll",
};

export const modalActionTypeEnum = {
    RENAME: "rename",
    CREATE: "create"
};


export const itemTypeEnum = {
    PROJECT: "project_lowercase",
    FOLDER: "folder_lowercase",
    PROCEDURE: "procedure_lowerCase",
    MEDIA_FOLDER: "mediaFolder_lowercase",
    FILE: "file_lowercase",
    TAG: "tag_lowercase",
    INTERACTION_FOLDER: "interaction_folder",
    INTERACTION: "interaction",
};

export const snackbarTypesEnum = {
    ERROR: "error",
    WARNING: "warning",
    INFO: "info",
    SUCCESS: "success"
};

export const resultsFiltersEnum = {
    ALL: 0,
    PROJECTS: 1,
    PROCEDURES: 2
};

export const batchOptions = [10, 20, 50]

export const ranks = [5, 4, 3, 2, 1]
